import { t } from "@repo/translation";
import { FilterCheckbox, useSettings } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const TypeFilter = ({ filters, actions }: FilterItemsProps) => {
  const { boka_config, feature_flags, quotation } = useSettings();

  return (
    <FilterListContainer id="opportunity-type-filter">
      <FilterCheckbox
        id="Sales Opportunity"
        label={t("type.sales_project")}
        checked={isChecked(filters.opportunityType, "Sales Opportunity")}
        onCheckFilter={actions.setOpportunityType}
        value="Sales Opportunity"
      />

      <FilterCheckbox
        id="Blocked Order"
        label={t("type.blocked_order")}
        checked={isChecked(filters.opportunityType, "Blocked Order")}
        onCheckFilter={actions.setOpportunityType}
        value="Blocked Order"
      />

      {boka_config?.enable && (
        <FilterCheckbox
          id="Boka"
          label={t("type.boka")}
          checked={isChecked(filters.opportunityType, "Boka")}
          onCheckFilter={actions.setOpportunityType}
          value="Boka"
        />
      )}
      {feature_flags?.b2b_enr_enabled && (
        <FilterCheckbox
          id="ENR"
          label="ENR"
          checked={isChecked(filters.opportunityType, "ENR")}
          onCheckFilter={actions.setOpportunityType}
          value="ENR"
        />
      )}
      {quotation?.enable_quotations_import && (
        <FilterCheckbox
          id="Quotation"
          label={t("label.quotation")}
          checked={isChecked(filters.opportunityType, "Quotation")}
          onCheckFilter={actions.setOpportunityType}
          value="Quotation"
        />
      )}
      {feature_flags?.enable_box_projects && (
        <FilterCheckbox
          id="Assistance Request"
          label={t("type.assistance_request")}
          checked={isChecked(filters.opportunityType, "Assistance Request")}
          onCheckFilter={actions.setOpportunityType}
          value="Assistance Request"
        />
      )}
    </FilterListContainer>
  );
};
